<template>
  <div>
    <!-- 顶部 报表名称 + 筛选条件 -->
    <report-search
      report-title="proConfig.process"
      @search="handleFilters"></report-search>
    <!-- 中部 环图-->
    <div class="chart-box ring">
      <a-row :gutter="24">
        <a-col :span="8">
          <div class="box">
            <div class="title">{{ $t('report.process.count') }}</div>
            <div class="chart count">
              <countTo :startVal="startVal" :endVal="amount" :duration="1500"></countTo>
            </div>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="box">
            <div class="title">{{ $t('report.process.task') }}</div>
            <div class="chart pie">
              <v-chart :forceFit="true" :padding="[15, 120, 0, 0]" :height="pieHeight" :data="jobSpreadData">
                <v-tooltip :showTitle="false" :inPlot="false" dataKey="procName*count" />
                <v-axis />
                <v-legend position="right-bottom" :offsetX="-10" dataKey="procName" />
                <v-pie position="count" color="procName" />
                <v-coord type="theta" :radius="0.75" :innerRadius="0.6" />
              </v-chart>
            </div>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="box">
            <div class="title">{{ $t('report.process.error') }}</div>
            <div class="chart pie">
              <v-chart :forceFit="true" :padding="[15, 120, 0, 0]" :height="pieHeight" :data="failedSpreadData">
                <v-tooltip :showTitle="false" :inPlot="false" dataKey="procName*count" />
                <v-axis />
                <v-legend position="right-bottom" :offsetX="-10" dataKey="procName" />
                <v-pie position="count" :color="failedColor" />
                <v-coord type="theta" :radius="0.75" :innerRadius="0.6" />
              </v-chart>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
    <!-- 中部 堆叠柱形图-->
    <div class="chart-box histogram">
      <a-row :gutter="24">
        <a-col :xxl="12" :xl="24">
          <div class="box">
            <div class="title">{{ $t('report.process.taskTrend') }}</div>
            <div class="chart">
              <v-chart :forceFit="true" :padding="['auto', 'auto', '50', 'auto']" :height="342" :data="trendData">
                <v-tooltip />
                <v-axis />
                <v-legend position="top-right" :offsetY="-40" />
                <v-stack-bar position="时间*任务数" color="name" />
              </v-chart>
            </div>
          </div>
        </a-col>
        <a-col :xxl="12" :xl="24">
          <div class="box">
            <div class="title">{{ $t('report.process.timeTrend') }}</div>
            <div class="chart">
              <v-chart :forceFit="true" :padding="['auto', 'auto', '50', 'auto']" :height="342" :data="timeTrendData">
                <v-tooltip />
                <v-axis />
                <v-legend position="top-right" :offsetY="-40" />
                <v-stack-bar position="时间*工作时长" color="name" />
              </v-chart>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
    <!-- 底部 表格列表 -->
    <div class="log_box">
      <div :class="{ title: true, isPos: pagination.total }">{{ $t('report.process.log') }}</div>
      <a-table :loading="loading" :columns="columns" :dataSource="dataList" :pagination="pagination">
        <!-- 状态 -->
        <span slot="status" slot-scope="text">
          <template>
            <i :class="`iconfont icon${text} ${text}`"></i>
            {{ taskStatus[text] }}
          </template>
        </span>
      </a-table>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import { apiProcessReport } from '@/api/reportProcess'
import { formatChartData } from '@/utils/util'

const DataSet = require('@antv/data-set')

export default {
  components: {
    countTo
  },
  data () {
    return {
      // 数据筛选条件
      initParams: {
        robotName: '', // 机器人名称
        procName: '', // 流程名
        queryStart: '', // 开始时间
        queryEnd: '', // 结束时间
        queryMode: '', // 查询模式  键值： 1 今天，2 昨天，3本周，4 上周，5 本月，6 上月
        interval: '' // 间隔
      },
      // countTo 的开始结束
      startVal: 0,
      amount: 0, // 流程数
      // 饼图相关
      pieHeight: 162,
      jobSpreadData: [], // 流程任务
      failedSpreadData: [], // 错误分布
      failedColor: ['procName', ['#E6AFB0', '#D88A8B', '#BB4143', '#BB4143', '#943536']],
      // 堆叠柱形相关
      trendData: [], // 任务趋势
      timeTrendData: [], // 时间趋势
      // 表格相关
      // 任务状态，键值对
      taskStatus: {
        pending: this.$t('task.status.pending'),
        pendout: this.$t('task.status.pendout'),
        running: this.$t('task.status.running'),
        succ: this.$t('task.status.success'),
        failing: this.$t('task.status.failing'),
        failed: this.$t('task.status.failed'),
        stopping: this.$t('task.status.stopping'),
        stopped: this.$t('task.status.stopped')
      },
      dataList: [],
      loading: false,
      columns: [
        {
          title: this.$t('roi.logTab[0]'),
          dataIndex: 'scheduleTime',
          customRender: text => {
            return text || '-'
          }
        },
        {
          title: this.$t('roi.logTab[1]'),
          dataIndex: 'robotName',
          customRender: text => {
            return text || '-'
          }
        },
        {
          title: this.$t('roi.logTab[2]'),
          dataIndex: 'procName',
          customRender: text => {
            return text || '-'
          }
        },
        {
          title: this.$t('roi.logTab[5]'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('roi.logTab[3]'),
          dataIndex: 'performTime',
          customRender: text => {
            return text === undefined ? '-' : text
          }
        },
        {
          title: this.$t('roi.logTab[4]'),
          dataIndex: 'artificialTime',
          customRender: text => {
            return text === undefined ? '-' : text
          }
        }
      ],
      pagination: {
        position: 'top',
        size: 'small',
        total: 0,
        showTotal: total => this.$t('operation.totalRecords', { total }),
        onChange: this.changePage
      }
    }
  },
  created () {
    this.handleFilters(this.initParams)
  },
  methods: {
    // 渲染环图的数据
    setPieViewData (ininData, field, dimension) {
      const pieDv = new DataSet.View().source(ininData)
      pieDv.transform({
        type: 'percent',
        field,
        dimension,
        as: 'percent'
      })
      return pieDv.rows
    },
    // 渲染堆叠柱形图的数据
    setHistogramViewData (ininData, fields, key, value) {
      const dv = new DataSet.View().source(ininData)
      dv.transform({
        type: 'fold',
        fields,
        key,
        value
      })
      return dv.rows
    },
    // 根据筛选条件获取对应的数据
    handleFilters (params) {
      // console.log(params)
      // 存储选择的筛选条件
      this.initParams = params
      // 机器人数
      apiProcessReport.amount(params).then(res => {
        // console.log(res)
        this.amount = Number(res || 0)
      })
      // 机器人任务分布
      apiProcessReport.jobSpread(params).then(res => {
        // console.log(res)
        this.jobSpreadData = this.setPieViewData(res || [{ count: 1,
          procName: this.$t('operation.notAvailable') }], 'count', 'procName')
      })
      // 机器人错误分布
      apiProcessReport.failedSpread(params).then(res => {
        // console.log(res)
        this.failedSpreadData = this.setPieViewData(res || [{ count: 1,
          procName: this.$t('operation.notAvailable') }], 'count', 'procName')
      })
      // 机器人任务数趋势堆叠图
      apiProcessReport.trend(params).then(res => {
        // console.log(res)
        const formatChartInfo = formatChartData(res, 'procName', 'time', 'count')
        // console.log(formatChartInfo)
        this.trendData = this.setHistogramViewData(formatChartInfo.chartData || [], formatChartInfo.xFields || [], '时间', '任务数')
      })
      // 机器人工作时间趋势堆叠图
      apiProcessReport.timeTrend(params).then(res => {
        // console.log(res)
        const formatChartInfo = formatChartData(res, 'procName', 'time', 'count')
        // console.log(formatChartInfo)
        this.timeTrendData = this.setHistogramViewData(formatChartInfo.chartData || [], formatChartInfo.xFields || [], '时间', '工作时长')
      })
      // 日志列表
      this.changePage(1)
    },
    /**
     * 任务日志列表
     */
    fetchList (params, cur) {
      this.loading = true
      apiProcessReport.logs(params, cur).then(data => {
        // console.log(data)
        this.dataList = data.items
        this.pagination.total = data.total
        this.loading = false
      })
    },
    /**
     * 日志分页
     */
    changePage (page) {
      this.fetchList(this.initParams, page)
    }
  }
}
</script>

<style lang="less" scoped>
  [class^=ant-col-],
  .log_box {
    box-shadow: 2px 3px 7px 1px rgba(239,241,245,0.64);
  }
  .chart-box {
    margin-top: 24px;
    [class^=ant-col-] {
      > div {
        background-color: #fff;
        padding: 24px;
      }
    }
    &.ring {
      .chart {
        height: 162px;
        overflow: hidden;
        &.count {
          display: flex;
          align-items: center;
          justify-content: center;
          /deep/span {
            font-weight: bold;
            font-size: 60px;
            color: #666;
          }
        }
      }
    }
    &.histogram {
      [class^=ant-col-] {
        margin-bottom: 24px;
        > div {
          padding: 0;
          padding-top: 15px;
        }
      }
      .title {
        position: absolute;
        width: 100%;
        color: #333;
        padding-left: 24px;
        padding-bottom: 15px;
        border-bottom: 1px solid #D9D9D9;
      }
      .box {
        position: relative;
      }
      .chart {
        height: 342px;
        padding: 0 24px 15px 24px;
      }
    }
  }
  .log_box {
    background: #fff;
    position: relative;
    padding-bottom: 30px;
    .ant-table-wrapper {
      padding: 0 24px;
    }
    .title {
      // position: absolute;
      &.isPos {
        position: absolute;
      }
      top: 0;
      left: 0;
      width: 100%;
      padding: 18px 24px;
      border-bottom: 1px solid #eee;
      font-size: 16px;
      color: #333;
    }
    /deep/.ant-table {
      padding-top: 13px;
    }
    /deep/.ant-pagination-item,
    /deep/.ant-pagination-item-ellipsis,
    /deep/.ant-pagination-jump-prev,
    /deep/.ant-pagination-jump-next {
      display: none;
    }
  }

  // 状态 icon 图标颜色
  .pending {
    color: #83D5FF;
  }
  .running {
    color: #4977FC;
  }
  .succ {
    color: #52C41A;
  }
  .failing {
    color: #FFB75F;
  }
  .failed {
    color: #333333;
  }
  .stopping {
    color: #EC6941;
  }
  .stopped {
    color: #F5222D;
  }
</style>
